import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {PlusOutlined} from '@ant-design/icons';
import {Button, Col, Row, Typography} from 'antd';
import {Content} from 'antd/es/layout/layout';
import {Shell} from 'components/Shell';
import {CarCard} from 'components/ui/cards/CarCard';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';
import {NotFoundView} from 'views/NotFoundView';
import {ReactComponent as CarIcon} from 'assets/images/car.svg';

export const GarageDisplayView: React.FC = observer(() => {
  const navigate = useNavigate();
  const {garageId} = useParams();
  const {t} = useTranslation();
  const garage = appState.getGarage(parseInt(garageId ?? ''));

  return (
    <>
      {garage ? (
        <Shell
          title={garage.name ?? ''}
          backLink
          actionButtons={[
            <Button
              key="edit"
              size="large"
              onClick={() => navigate(AppRoutePaths.garages.url + `/${garageId}/edit`)}
              className="shell-btn"
            >
              {t('Edit garage')}
            </Button>,
            <Button
              key="add"
              size="large"
              type="primary"
              onClick={() => navigate(AppRoutePaths.garages.url + `/${garageId}/add_vehicle`)}
              className="shell-btn"
              icon={<PlusOutlined />}
            >
              {t('Add car')}
            </Button>,
          ]}
        >
          {garage.garageSpots?.length ? (
            <Row gutter={[16, 16]}>
              {garage.garageSpots &&
                garage.garageSpots
                  .filter(({car}) => car?.carId !== undefined)
                  .map(({car}) => (
                    <Col key={car?.carId} className="gutter-row" xs={24} sm={24} md={12} lg={6} xl={6}>
                      {car && <CarCard car={car} garageId={Number(garageId)} />}
                    </Col>
                  ))}
            </Row>
          ) : (
            <Content style={{textAlign: 'center'}}>
              <CarIcon />
              <Typography.Paragraph strong>{t('Your garage is empty.')}</Typography.Paragraph>
              <Typography.Paragraph strong>{t('Please, add a new car.')}</Typography.Paragraph>
            </Content>
          )}
        </Shell>
      ) : (
        <NotFoundView />
      )}
    </>
  );
});
